import React, { useState } from "react";
import JobTypeListing from "../listing";
import HourlyFilters from "./filters";
import { TypeStatsSection } from "../components/type-stats-section";

export default function HourlyJobs() {

  const [filters,setFilters]=useState({})
  

  return (
    <JobTypeListing 
      type="hourly" 
      title="Hourly Jobs" 
      filters={HourlyFilters}
     onFiltersChange={setFilters}
      renderContent={() => (
        <TypeStatsSection jobType="hourly" filters={filters} />
      )}
    />
  );
}
